<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-loop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.002 23v6.024c0 5.545-4.477 10.04-10 10.04H18v3.594a1 1 0 01-1.563.827l-8.23-5.605a1 1 0 01-.004-1.65l8.23-5.664A1 1 0 0118 31.39v3.658h14.002c3.313 0 6-2.697 6-6.024V23h4zm-11-17.11a1 1 0 01.563.174l8.23 5.605a1 1 0 01.004 1.65l-8.23 5.664a1 1 0 01-1.567-.824v-3.658H16c-3.314 0-6 2.697-6 6.024v6.024H6v-6.024c0-5.545 4.477-10.04 10-10.04h14.002V6.891a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconLoop',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
